import React from 'react'
import InteractiveContentRenderer from '../interactive/InteractiveContentRenderer'
import { normalizeBlocks, lessonCtx, PROMPT_BLOCK_SPEC } from '../../features/lesson-builder/types/blocks'

// Trang test BƯỚC 1 (P1): kiểm chứng mọi LOẠI KHỐI của "hợp đồng" render đúng qua đường
// render thật của thẻ bài giảng (InteractiveContentRenderer), gồm cả normalizeBlocks +
// resolve simulation_ref. Route: /demo/khoi-bai-giang
const IMG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="320" height="120"><rect width="320" height="120" fill="#dbeafe"/><text x="160" y="66" font-size="18" fill="#1d4ed8" text-anchor="middle">Ảnh minh hoạ (test content→src)</text></svg>'
)

const SAMPLE: any[] = [
  { type: 'heading', level: 2, content: 'Heading cấp 2' },
  { type: 'text', content: 'Khối **text** markdown + công thức $x = A\\cos(\\omega t + \\varphi)$.' },
  { type: 'formula', content: 'a = -\\omega^2 x', explanation: 'Gia tốc tỉ lệ ngược li độ', display: true },
  { type: 'list', style: 'bullet', items: ['Biên độ A', 'Tần số góc ω', 'Pha ban đầu φ'] },
  { type: 'table', title: 'Đại lượng đặc trưng', headers: ['Đại lượng', 'Kí hiệu'], rows: [['Biên độ', 'A'], ['Chu kì', 'T'], ['Tần số góc', 'ω']] },
  { type: 'image', content: IMG, alt: 'minh hoạ' },
  { type: 'concept_card', title: 'Kiến thức trọng tâm', content: 'Dao động điều hoà: li độ biến thiên theo hàm cos của thời gian.' },
  { type: 'example', title: 'Ví dụ 1', content: 'Cho A = 5 cm, T = 2 s. Tính ω. Lời giải: ω = 2π/T = π rad/s.' },
  { type: 'warning', title: 'Lưu ý', content: 'Không nhầm tần số f với tần số góc ω = 2πf.' },
  { type: 'conclusion_card', title: 'Tổng kết', content: 'Ghi nhớ: x = A·cos(ωt + φ); a = −ω²x.' },
  { type: 'interactive_question', question: 'ω là đại lượng nào?', options: ['Tần số góc', 'Biên độ', 'Pha ban đầu'], correctAnswer: 0, explanation: 'ω = 2πf.', hint: 'Đơn vị rad/s.' },
  { type: 'multiple_response_question', question: 'Chọn các đại lượng đặc trưng của dao động điều hoà:', options: ['Biên độ', 'Tần số góc', 'Pha ban đầu', 'Khối lượng riêng'], correctAnswers: [0, 1, 2], explanation: 'Khối lượng riêng không phải đặc trưng dao động.' },
  { type: 'sequence_question', question: 'Sắp xếp các bước lập phương trình dao động:', items: ['Viết x = A·cos(ωt+φ)', 'Xác định A', 'Xác định ω', 'Xác định φ'], correctSequence: [1, 2, 3, 0], explanation: 'Tìm A, ω, φ rồi ghép.' },
  { type: 'quiz', title: 'Câu hỏi củng cố', questions: [
    { type: 'multiple_choice', question: 'Đơn vị của ω?', options: ['Hz', 'rad/s', 'm/s', 's'], correct: 1, explanation: 'rad/s.', points: 0.25 },
    { type: 'true_false', question: 'ω = 2πf đúng không?', correct: true, explanation: 'Đúng.', points: 1 },
  ] },
  { type: 'khoi_la_khong_biet', content: 'Khối lạ — sẽ bị hạ về text để không mất nội dung.' },
  { type: 'simulation_ref', note: 'Chèn mô phỏng dao động của bài (Lớp 11 / Chương 1 / Bài 1)' },
]

const KhoiBaiGiangDemo: React.FC = () => {
  const ctx = lessonCtx({ lop: '11', chuong: '1', bai: '1' })
  const items = normalizeBlocks(SAMPLE, ctx)
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-black text-gray-800">Test khối bài giảng (Bước 1 — P1)</h1>
      <p className="text-gray-500 text-sm">
        Render {SAMPLE.length} khối mẫu qua đúng đường thẻ <b>rich</b> (InteractiveContentRenderer + normalizeBlocks).
        Khối <code>simulation_ref</code> được tự thay bằng mô phỏng dao động (Lớp 11/Ch.1/Bài 1); khối lạ bị hạ về text.
      </p>
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <InteractiveContentRenderer content={items} />
      </div>
      <details className="rounded-lg border border-gray-200 bg-slate-50 p-3 text-xs text-gray-600">
        <summary className="cursor-pointer font-semibold">Đặc tả hợp đồng khối (PROMPT_BLOCK_SPEC)</summary>
        <pre className="whitespace-pre-wrap mt-2">{PROMPT_BLOCK_SPEC}</pre>
      </details>
    </div>
  )
}
export default KhoiBaiGiangDemo
